export enum CEFRLevelEnum {
  A1 = 'A1',
  A1_OR_HIGHER = 'A1+',
  A2_OR_LOWER = 'A2-',
  A2 = 'A2',
  A2_OR_HIGHER = 'A2+',
  B1_OR_LOWER = 'B1-',
  B1 = 'B1',
  B1_OR_HIGHER = 'B1+',
  B2_OR_LOWER = 'B2-',
  B2 = 'B2',
  B2_OR_HIGHER = 'B2+',
  C1_OR_LOWER = 'C1-',
  C1 = 'C1',
  C1_OR_HIGHER = 'C1+',
  C2 = 'C2',
}

export enum LanguagesEnum {
  abk = 'Abkhazian',
  aar = 'Afar',
  afr = 'Afrikaans',
  aka = 'Akan',
  sqi = 'Albanian',
  amh = 'Amharic',
  ara = 'Arabic',
  hye = 'Armenian',
  asm = 'Assamese',
  aym = 'Aymara',
  aze = 'Azerbaijani',
  bal = 'Balochi',
  bam = 'Bambara',
  bak = 'Bashkir',
  eus = 'Basque',
  bel = 'Belarusian',
  ben = 'Bengali',
  bis = 'Bislama',
  bos = 'Bosnian',
  bul = 'Bulgarian',
  mya = 'Burmese',
  yue = 'Cantonese',
  cat = 'Catalan',
  tzm = 'Central Atlas Tamazight',
  che = 'Chechen',
  nya = 'Chewa',
  zho = 'Chinese',
  hrv = 'Croatian',
  ces = 'Czech',
  ada = 'Dangme',
  dan = 'Danish',
  div = 'Dhivehi',
  doi = 'Dogri',
  nld = 'Dutch',
  dzo = 'Dzongkha',
  eng = 'English',
  est = 'Estonian',
  ewe = 'Ewe',
  fij = 'Fijian',
  fil = 'Filipino',
  fin = 'Finnish',
  fon = 'Fon',
  fra = 'French',
  ful = 'Fula',
  glg = 'Galician',
  kat = 'Georgian',
  deu = 'German',
  gil = 'Gilbertese',
  ell = 'Greek',
  grn = 'Guarani',
  guj = 'Gujarati',
  hat = 'Haitian Creole',
  hau = 'Hausa',
  heb = 'Hebrew',
  hin = 'Hindi',
  hun = 'Hungarian',
  isl = 'Icelandic',
  ibo = 'Igbo',
  ind = 'Indonesian',
  gle = 'Irish',
  ita = 'Italian',
  jpn = 'Japanese',
  jav = 'Javanese',
  kab = 'Kabyle',
  kan = 'Kannada',
  kas = 'Kashmiri',
  kaz = 'Kazakh',
  khm = 'Khmer',
  kmb = 'Kimbundu',
  kin = 'Kinyarwanda',
  run = 'Kirundi',
  kon = 'Kongo',
  kor = 'Korean',
  kur = 'Kurdish',
  kir = 'Kyrgyz',
  lao = 'Lao',
  lav = 'Latvian',
  lin = 'Lingala',
  lit = 'Lithuanian',
  ltz = 'Luxembourgish',
  mkd = 'Macedonian',
  mai = 'Maithili',
  mlg = 'Malagasy',
  msa = 'Malay',
  mal = 'Malayalam',
  mlt = 'Maltese',
  cmn = 'Mandarin Chinese',
  mri = 'Māori',
  mar = 'Marathi',
  mah = 'Marshallese',
  mni = 'Meitei',
  mon = 'Mongolian',
  cnr = 'Montenegrin',
  mos = 'Mooré',
  nau = 'Nauru',
  nep = 'Nepali',
  nde = 'Northern Ndebele',
  nor = 'Norwegian',
  ori = 'Odia',
  orm = 'Oromo',
  oss = 'Ossetian',
  zzz = 'Other',
  kua = 'Kwanyama',
  pau = 'Palauan',
  pus = 'Pashto',
  fas = 'Persian',
  pol = 'Polish',
  por = 'Portuguese',
  pan = 'Punjabi',
  que = 'Quechua',
  rom = 'Romani',
  ron = 'Romanian',
  rus = 'Russian',
  smi = 'Sámi',
  smo = 'Samoan',
  sag = 'Sango',
  sat = 'Santali',
  sco = 'Scots',
  gla = 'Scottish Gaelic',
  nso = 'Sepedi',
  srp = 'Serbian',
  sot = 'Sesotho',
  sna = 'Shona',
  snd = 'Sindhi',
  sin = 'Sinhala',
  slk = 'Slovak',
  slv = 'Slovenian',
  som = 'Somali',
  snk = 'Soninke',
  nbl = 'Southern Ndebele',
  spa = 'Spanish',
  sun = 'Sundanese',
  swa = 'Swahili',
  ssw = 'Swazi',
  swe = 'Swedish',
  tgl = 'Tagalog',
  tgk = 'Tajik',
  tmh = 'Tamasheq',
  tam = 'Tamil',
  shi = 'Tachelhit',
  tat = 'Tatar',
  tel = 'Telugu',
  tet = 'Tetum',
  tha = 'Thai',
  bod = 'Tibetan',
  tig = 'Tigre',
  tir = 'Tigrinya',
  tpi = 'Tok Pisin',
  ton = 'Tongan',
  tso = 'Tsonga',
  tsn = 'Tswana',
  tum = 'Tumbuka',
  tur = 'Turkish',
  tuk = 'Turkmen',
  tvl = 'Tuvaluan',
  ukr = 'Ukrainian',
  umb = 'Umbundu',
  urd = 'Urdu',
  uig = 'Uyghur',
  uzb = 'Uzbek',
  ven = 'Venda',
  vie = 'Vietnamese',
  cym = 'Welsh',
  wol = 'Wolof',
  xho = 'Xhosa',
  yor = 'Yoruba',
  zha = 'Zhuang',
  zul = 'Zulu',
}

export enum GenderEnum {
  male = 'Male',
  female = 'Female',
  nonBinary = 'Non-binary',
}

export enum EducationEnum {
  none = 'No Formal Education',
  primarySchool = 'Middle School/Primary School',
  secondarySchool = 'High School/Secondary School',
  vocationalTraining = 'Vocational Training',
  bachelorsDegree = "Bachelor's Degree (e.g., BA, BSc)",
  mastersDegree = "Master's Degree (e.g., MA, MEng)",
  doctorateDegree = 'Doctorate (e.g., PhD)',
}

export enum OccupationEnum {
  admin = 'Administrative Services',
  agriculture = 'Agriculture',
  arts = 'Arts',
  construction = 'Construction',
  education = 'Education',
  energy = 'Energy & Utilities',
  finance = 'Finance',
  government = 'Government',
  healthcare = 'Healthcare',
  hospitality = 'Hospitality',
  legal = 'Legal & Consulting',
  manufacturing = 'Manufacturing',
  media = 'Media & Entertainment',
  real_estate = 'Real Estate',
  retail = 'Retail',
  sales = 'Sales',
  student = 'Student',
  technology = 'Technology',
  transport = 'Transport',
  other = 'Other',
}

export enum CountriesEnum {
  AF = 'Afghanistan',
  AX = 'Åland Islands',
  AL = 'Albania',
  DZ = 'Algeria',
  AS = 'American Samoa',
  AD = 'Andorra',
  AO = 'Angola',
  AI = 'Anguilla',
  AG = 'Antigua and Barbuda',
  AR = 'Argentina',
  AM = 'Armenia',
  AW = 'Aruba',
  AU = 'Australia',
  AT = 'Austria',
  AZ = 'Azerbaijan',
  BS = 'Bahamas',
  BH = 'Bahrain',
  BD = 'Bangladesh',
  BB = 'Barbados',
  BY = 'Belarus',
  BE = 'Belgium',
  BZ = 'Belize',
  BJ = 'Benin',
  BM = 'Bermuda',
  BT = 'Bhutan',
  BO = 'Bolivia',
  BA = 'Bosnia and Herzegovina',
  BW = 'Botswana',
  BR = 'Brazil',
  VG = 'British Virgin Islands',
  BN = 'Brunei',
  BG = 'Bulgaria',
  BF = 'Burkina Faso',
  BI = 'Burundi',
  CV = 'Cabo Verde',
  KH = 'Cambodia',
  CM = 'Cameroon',
  CA = 'Canada',
  BQ = 'Caribbean Netherlands',
  KY = 'Cayman Islands',
  CF = 'Central African Republic',
  TD = 'Chad',
  CL = 'Chile',
  CN = 'China',
  CO = 'Colombia',
  KM = 'Comoros',
  CK = 'Cook Islands',
  CR = 'Costa Rica',
  CI = "Côte d'Ivoire",
  HR = 'Croatia',
  CU = 'Cuba',
  CW = 'Curaçao',
  CY = 'Cyprus',
  CZ = 'Czechia',
  CD = 'Democratic Republic of the Congo',
  DK = 'Denmark',
  DJ = 'Djibouti',
  DM = 'Dominica',
  DO = 'Dominican Republic',
  EC = 'Ecuador',
  EG = 'Egypt',
  SV = 'El Salvador',
  GQ = 'Equatorial Guinea',
  ER = 'Eritrea',
  EE = 'Estonia',
  SZ = 'Eswatini',
  ET = 'Ethiopia',
  FO = 'Faroe Islands',
  FJ = 'Fiji',
  FI = 'Finland',
  FR = 'France',
  GF = 'French Guiana',
  PF = 'French Polynesia',
  GA = 'Gabon',
  GM = 'Gambia',
  GE = 'Georgia',
  DE = 'Germany',
  GH = 'Ghana',
  GI = 'Gibraltar',
  GR = 'Greece',
  GL = 'Greenland',
  GD = 'Grenada',
  GP = 'Guadeloupe',
  GU = 'Guam',
  GT = 'Guatemala',
  GG = 'Guernsey',
  GN = 'Guinea',
  GW = 'Guinea-Bissau',
  GY = 'Guyana',
  HT = 'Haiti',
  HN = 'Honduras',
  HK = 'Hong Kong',
  HU = 'Hungary',
  IS = 'Iceland',
  IN = 'India',
  ID = 'Indonesia',
  IR = 'Iran',
  IQ = 'Iraq',
  IE = 'Ireland',
  IM = 'Isle of Man',
  IL = 'Israel',
  IT = 'Italy',
  JM = 'Jamaica',
  JP = 'Japan',
  JE = 'Jersey',
  JO = 'Jordan',
  KZ = 'Kazakhstan',
  KE = 'Kenya',
  KI = 'Kiribati',
  XK = 'Kosovo',
  KW = 'Kuwait',
  KG = 'Kyrgyzstan',
  LA = 'Laos',
  LV = 'Latvia',
  LB = 'Lebanon',
  LS = 'Lesotho',
  LR = 'Liberia',
  LY = 'Libya',
  LI = 'Liechtenstein',
  LT = 'Lithuania',
  LU = 'Luxembourg',
  MO = 'Macau',
  MG = 'Madagascar',
  MW = 'Malawi',
  MY = 'Malaysia',
  MV = 'Maldives',
  ML = 'Mali',
  MT = 'Malta',
  MH = 'Marshall Islands',
  MQ = 'Martinique',
  MR = 'Mauritania',
  MU = 'Mauritius',
  YT = 'Mayotte',
  MX = 'Mexico',
  FM = 'Micronesia',
  MD = 'Moldova',
  MC = 'Monaco',
  MN = 'Mongolia',
  ME = 'Montenegro',
  MA = 'Morocco',
  MZ = 'Mozambique',
  MM = 'Myanmar',
  NA = 'Namibia',
  NR = 'Nauru',
  NP = 'Nepal',
  NL = 'Netherlands',
  NC = 'New Caledonia',
  NZ = 'New Zealand',
  NI = 'Nicaragua',
  NE = 'Niger',
  NG = 'Nigeria',
  KP = 'North Korea',
  MK = 'North Macedonia',
  MP = 'Northern Mariana Islands',
  NO = 'Norway',
  OM = 'Oman',
  PK = 'Pakistan',
  PW = 'Palau',
  PS = 'Palestine',
  PA = 'Panama',
  PG = 'Papua New Guinea',
  PY = 'Paraguay',
  PE = 'Peru',
  PH = 'Philippines',
  PL = 'Poland',
  PT = 'Portugal',
  PR = 'Puerto Rico',
  QA = 'Qatar',
  CG = 'Republic of the Congo',
  RE = 'Réunion',
  RO = 'Romania',
  RU = 'Russia',
  RW = 'Rwanda',
  BL = 'Saint Barthélemy',
  KN = 'Saint Kitts and Nevis',
  LC = 'Saint Lucia',
  MF = 'Saint Martin',
  VC = 'Saint Vincent and the Grenadines',
  WS = 'Samoa',
  SM = 'San Marino',
  ST = 'São Tomé and Príncipe',
  SA = 'Saudi Arabia',
  SN = 'Senegal',
  RS = 'Serbia',
  SC = 'Seychelles',
  SL = 'Sierra Leone',
  SG = 'Singapore',
  SX = 'Sint Maarten',
  SK = 'Slovakia',
  SI = 'Slovenia',
  SB = 'Solomon Islands',
  SO = 'Somalia',
  ZA = 'South Africa',
  KR = 'South Korea',
  SS = 'South Sudan',
  ES = 'Spain',
  LK = 'Sri Lanka',
  SD = 'Sudan',
  SR = 'Suriname',
  SE = 'Sweden',
  CH = 'Switzerland',
  SY = 'Syria',
  TW = 'Taiwan',
  TJ = 'Tajikistan',
  TZ = 'Tanzania',
  TH = 'Thailand',
  TL = 'Timor-Leste',
  TG = 'Togo',
  TO = 'Tonga',
  TT = 'Trinidad and Tobago',
  TN = 'Tunisia',
  TR = 'Türkiye',
  TM = 'Turkmenistan',
  TC = 'Turks and Caicos Islands',
  TV = 'Tuvalu',
  UG = 'Uganda',
  UA = 'Ukraine',
  AE = 'United Arab Emirates',
  GB = 'United Kingdom',
  US = 'United States',
  UY = 'Uruguay',
  VI = 'U.S. Virgin Islands',
  UZ = 'Uzbekistan',
  VU = 'Vanuatu',
  VA = 'Vatican City',
  VE = 'Venezuela',
  VN = 'Vietnam',
  WF = 'Wallis and Futuna',
  EH = 'Western Sahara',
  YE = 'Yemen',
  ZM = 'Zambia',
  ZW = 'Zimbabwe',
}
